import * as React from "react";
import {useImperativeHandle, forwardRef, JSX} from "react";
import Box from "@mui/material/Box";
import "@fontsource/lato";
import "@fontsource/montserrat";
// @ts-ignore TODO ts-ignore
import {Theme} from "../Components/styles/styles.js";
import {ThemeProvider} from "@mui/material/styles";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Divider from '@mui/material/Divider';
import "./HorizontalMenu.css";
import MenuConst, {MenuProps} from "./MenuConst";

export interface HorizontalMenuRef {
    deselectItem: () => void;
    selectItem: (ix: number) => void;
}

export interface HorizontalMenuProps extends MenuProps{
    menuList: string[];
    menuAdmin: boolean[];
    setMenuIx: (index: number) => void;
    isAdmin: boolean;
}

export const HorizontalMenu = forwardRef<HorizontalMenuRef, HorizontalMenuProps>((props, ref): JSX.Element => {
    const [clickedId, setClickedId] = React.useState(MenuConst.NONE);

    useImperativeHandle(ref, (): { deselectItem: () => void; selectItem: (i: number) => void; } => ({
        deselectItem: (): void => {
            setClickedId(MenuConst.NONE);
            props.setMenuIx(MenuConst.NONE);
        },
        selectItem: (i: number): void => {
            setClickedId(i);
            props.setMenuIx(i);
        }
    }));

    const handleClick = (i: number): void => {
        setClickedId(i);
        props.setMenuIx(i);
    };

    const isVisible = (id: number, menuAdmin: boolean[], isAdmin: boolean): boolean => {

        if (MenuConst.NONE === id) {
            return false;
        }

        if (isAdmin) {
            return menuAdmin[id];
        }

        return true;
    }

    return (
        <Stack className='horizontal-menu'
               direction="row"
               spacing={2}
               justifyContent="space-around"
               alignItems="flex-end"
        >
            <ThemeProvider theme={Theme}>
                {props.menuList.map((item, i): false | JSX.Element => (
                    isVisible(i, props.menuAdmin, props.isAdmin) && (
                        <Box className='menu-item' key={i}>
                            <Button
                                key={i}
                                name={item}
                                onClick={(): void => handleClick(i)}
                                sx={{
                                    ...Theme.textMenuButton,
                                    ...(i === clickedId && {color: "#363636"}),
                                }}

                            >
                                {item}
                            </Button>
                            {(i === clickedId) && <Divider className='active-choose'
                                                           sx={{
                                                               borderBottomWidth: 5,
                                                               bgcolor: "#2af9be"
                                                           }}/>}
                        </Box>
                    )
                ))}
            </ThemeProvider>
        </Stack>
    );
});
